import { render, staticRenderFns } from "./PopitPrize.vue?vue&type=template&id=187858b8&scoped=true&"
import script from "./PopitPrize.vue?vue&type=script&lang=js&"
export * from "./PopitPrize.vue?vue&type=script&lang=js&"
import style0 from "./PopitPrize.vue?vue&type=style&index=0&id=187858b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187858b8",
  null
  
)

export default component.exports